import { Criterion, Form, useForm, useRecruitment, useSession } from '@app/api';

export const useFormSession = (
  sessionId: string,
): {
  SessionForm: Form | undefined;
  SessionCriteria: Criterion[] | undefined;
} => {
  const { data: Session } = useSession(sessionId);
  const { data: recruitment } = useRecruitment(Session?.recruitmentId);

  const formId = recruitment ? recruitment.screeningFormId : undefined;
  const SessionCriteria = recruitment?.criteria;
  const { data: SessionForm } = useForm(formId);

  return { SessionForm, SessionCriteria };
};
